import React from 'react'

import FreeTrialForm from '@/components/Pages/FreeTrial/FreeTrialForm'
import FeatureRows from '@/components/sections/FeatureRows'
import { Column, Layout, Row, Rows, Section } from '@/components/layout'
import { Text, Button } from '@/components/common'
import { NEAT_NO_CC_SKU, ORDER_SOURCE } from '@/constants'

import styles from './FreeTrial.module.scss'

const pageId = 'freeTrial'

const scrollToTop = () => {
  const element = document.documentElement
  element.scrollIntoView({ behavior: 'smooth' })
}

export default function FreeTrial() {
  return (
    <Layout.Content>

      <Section bgForeground className={styles.freeTrialHeader}>
        <Row>
          <Column>
            <Rows className={styles.headerLeft} gap={8}>
              <Text.P bold brandSecondary noMargin size="small" type="display">No Credit Card Required</Text.P>
              <Text.H1 onTint size="large">Come Back & Try Neat for a 30-Day Trial</Text.H1>
              <Text.P noMargin onTint size="small">
                Start tracking receipts & documents. Organize & declutter along with increasing efficiency.
              </Text.P>
              <Text.P noMargin onTint size="xsmall">
                Neat is a yearly subscription where you can add on solutions.
              </Text.P>
            </Rows>
          </Column>
          <Column>
            <Rows className={styles.freeTrialFormContainer}>
              <FreeTrialForm planSku={NEAT_NO_CC_SKU} source={ORDER_SOURCE.NO_CC_TRIAL} />
            </Rows>
          </Column>
        </Row>
      </Section>

      <Section>
        <Text.H2 brandPrimary center style={{ marginBottom: '40px' }}>
          Unleash the power<br /> of your data
        </Text.H2>

        <FeatureRows />
      </Section>

      <Section>
        <Text.H2 center>Easy and efficient - now that&apos;s Neat!</Text.H2>
        <Button messageId="pages.freeTrial.ctaText" onClick={scrollToTop} size="xlarge" variant="primary" />
        <Text center size="xsmall">No Credit Card Required</Text>
      </Section>

    </Layout.Content>
  )
}

FreeTrial.layoutProps = {
  pageId,
  logoOnlyHeader: true,
  noNavFooter: true,
  showTopBar: false,
  shouldRobotsIndex: false,
}
